<template>
  <section class="section">
    <h1 class="title">Empleados a encuestar Cultura</h1>
    <progress
        v-show="avaceupload > 0"
        class="progress is-info is-small"
        :value="avaceupload"
        max="100"
    ></progress>
    <div class="columns">
      <div class="column">
        <p class="control has-icons-left has-icons-right">
          <input
              class="input is-medium is-focused"
              type="text"
              v-model="search"
              placeholder="Buscar Empleado"
          />
          <span class="icon is-medium is-left">
          <i class="material-icons">search</i>
        </span>
        </p>
      </div>
      <div class="column">
        <div class="is-flex">
          <span data-tooltip="Descargar Frases" class="tooltip">
          <button class="button is-medium"  @click="frases">
            <span class="file-icon">
              <i class="material-icons">cloud_download</i>
            </span>
            <span>20 Frases</span>
          </button>
        </span>
          <span data-tooltip="Descargar los usuarios pendientes" class="tooltip">
          <button class="button is-medium is-link " style="margin-left: 10px" @click="excelPendientes">
            <span class="file-icon">
              <i class="material-icons">cloud_download</i>
            </span>
            <span>Descargar Pendientes</span>
          </button>
        </span>
          <span data-tooltip="Enviar correo a todos los pendientes" class="tooltip">
            <button class="button is-medium is-dark" style="margin-left: 10px" @click="confirmSendAll">
              <span class="icon">
                <i class="material-icons">email</i>
              </span>
              <span>Enviar</span>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="is-block scroll-table scroll-light is-white">
      <table class="table is-fullwidth">
        <thead class="head-stick">
        <tr>
          <th>{{ filteredItems.length }}</th>
          <th>Correo</th>
          <th>Cédula</th>
          <th>Nombre</th>
          <th>Status</th>
          <th>
            <button class="is-fullwidth button is-danger" @click="deleteAll">
              <span class="icon">
                <i class="material-icons">delete_forever</i>
              </span>
              <span>Eliminar todos</span>
            </button>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredItems" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.cedula }}</td>
          <td>{{ item.nombre }}</td>
          <td>{{ item.status }}</td>
          <td>
            <div class="buttons">
              <button
                  @click="deleteoneemployee(item)"
                  class="button is-danger tooltip"
                  data-tooltip="Eliminar"
              >
                  <span class="icon">
                    <i class="material-icons">delete_forever</i>
                  </span>
              </button>
              <button
                  class="button is-dark tooltip"
                  data-tooltip="Enviar encuesta"
                  @click="enviarcorreo(item)"
              >
                  <span class="icon">
                    <i class="material-icons">email</i>
                  </span>
              </button>
              <button
                  class="button is-link"
                  @click="downloadresponses([item.responses, item.nombre])"
              >
                <span data-tooltip="Descargar Respuestas" class="icon tooltip">
                  <i class="material-icons">cloud_download</i>
                </span>
              </button>
              <button
                  class="button is-link tooltip"
                  data-tooltip="Link Encuesta"
                  @click="linkencuesta(item._id)"
              >
                  <span class="icon">
                    <i class="material-icons">share</i>
                  </span>
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <br>
    <div class="container columns">
      <div class="is-flex">
        <span data-tooltip="Cargar Excel de datos" class="tooltip file is-dark">
          <label class="file-label">
            <input
                class="file-input"
                type="file"
                accept=".xls, .xlsx"
                @change="onFileChange"
                name="resume"
                ref='uploadData'
            />
            <span class="file-cta">
            <span class="file-icon">
              <i class="material-icons">cloud_upload</i>
            </span>
            <span class="file-label">Cargar</span>
          </span>
          </label>
        </span>
        <span data-tooltip="Descargar ejemplo de datos" class="tooltip">
          <button class="button is-link"
                  @click="downexemple"
                  style="margin-left: 10px"
          >
            <span class="file-icon">
              <i class="material-icons">cloud_download</i>
            </span>
            <span>Ejemplo</span>
          </button>
        </span>
        <span v-if='nosave.length > 0' data-tooltip="Descargar personas no guardadas" class="tooltip">
          <button class="button is-danger"
                  @click="excelNog"
                  style="margin-left: 10px"
          >
            <span class="file-icon">
              <i class="material-icons">cloud_download</i>
            </span>
            <span>No guardados</span>
          </button>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import apiServices from "@/services/yungol-services";
import {mapState} from "vuex";

const XLSX = require("xlsx");

const filterItems = (query, data) => {
  return data.filter((el) => {
    const texto = el.email + el.nombre + el.cedula;
    if (texto.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      return el;
    }
  });
};

export default {
  props: {
    proceso: {
      type: Object,
    },
  },
  data() {
    return {
      employees: [],
      chargeEmployee: false,
      search: "",
      fupload: {
        url: "",
      },
      avaceupload: 0,
      dataToExport: [],
      nosave: []
    };
  },
  computed: {
    ...mapState(["modalnotification"]),
    filteredItems: function () {
      return filterItems(this.search, this.employees);
    },
    resultnotification() {
      return this.modalnotification.result;
    },
  },
  methods: {
    async frases() {
      try {
        let result;
        result = await apiServices.post(
            `/frasescultura`,
            {proceso: this.proceso._id},
            {responseType: "blob"}
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Frases.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
    async downexemple() {
      try {
        let result;
        result = await apiServices.post(
            `/downexempleempleadoscultura2`,
            {proceso: this.proceso._id},
            {responseType: "blob"}
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.refexcel(file);
        _this.avaceupload = 10;
        task.on(
            "state_changed",
            (snapshot) => {
              const porcentaje =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              if (porcentaje > 10) {
                _this.avaceupload = porcentaje;
              }
            },
            (err) => {
              console.log("error subiendo el archivo", err);
            },
            async () => {
              try {
                const url = await task.snapshot.ref.getDownloadURL();
                _this.avaceupload = 0;
                _this.fupload.url = url;
                const data = {
                  url: url,
                  proceso: this.proceso._id,
                };
                const result = await apiServices.post(
                    `/saveempleadoslotecultura2`,
                    data
                );
                if (result.data) {
                  await this.findEmployeesCohorte();
                  await this.calculateallcultura()
                  if (result.data.nosave){
                    this.$store.dispatch("notify", {
                      message: `${result.data.nosave.length} ${result.data.nosave.length ===1? 'persona tiene':'personas tienen'} más de 100 puntos en una variable`,
                      type: "is-danger",
                    });
                    this.nosave = result.data.nosave
                  }else{
                    if (this.nosave.length > 0){
                      this.nosave = []
                    }
                  }
                  this.$refs.uploadData.value = null
                }
              } catch (err) {
                console.log("ocurrio un error", err);
              }
            }
        );
      }
    },
    async calculateallcultura() {
      try {
        await apiServices.post(`/calculateallemployeecultura`, {
          proceso: this.proceso._id,
        });
        this.findEmployeesCohorte();
      } catch (err) {
        console.log(err);
      }
    },
    calculateall() {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: `A partir de este momento no se podrán seguir contestando encuestas. Las encuestas quedan cerradas`,
          clase: "is-white",
          data: {
            tipo: "calculateall",
          },
        },
      });
    },
    confirmSendAll() {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: "Realmente desea enviar todos los correos pendientes?",
          clase: "is-white",
          data: 'confirm',
        },
      })
    },
    async sendall() {
      let result;
      const d = {
        proceso: this.proceso._id,
      };
      try {
        result = await apiServices.post(`/enviarcorreolotecultura`, d);
        // this.datafile = result.data;
        if (result.data) {
          this.$store.dispatch("notify", {
            message: "Correos enviados.",
          });
        }
        this.findEmployeesCohorte();
      } catch (error) {
        console.log(error);
      }
    },
    async enviarcorreo(item) {
      let result;
      const d = {
        id: item._id,
      };
      try {
        result = await apiServices.post(`/enviarcorreocultura`, d);
        // this.datafile = result.data;
        if (result.data) {
          this.$store.dispatch("notify", {
            message: "Correo enviado con éxito.",
          });
        }
        this.findEmployeesCohorte();
      } catch (error) {
        console.log(error);
      }
    },
    linkencuesta: function (d) {
      let textArea = document.createElement("textarea");

      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;

      // Ensure it has a small width and height. Setting to 1px / 1em
      // doesn't work as this gives a negative w/h on some browsers.
      textArea.style.width = '2em';
      textArea.style.height = '2em';

      // We don't need padding, reducing the size if it does flash render.
      textArea.style.padding = 0;

      // Clean up any borders.
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';

      // Avoid flash of the white box if rendered for any reason.
      textArea.style.background = 'transparent';

      textArea.value = window.location.host + "/encuestacultura/" + d;

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        let successful = document.execCommand('copy')
        let msg = successful ? '¡Copiado al portapapeles!' : 'Error al copiar'
        let type = successful ? 'is-link' : 'is-danger'

        this.$store.dispatch("notify", {
          message: msg,
          type: type,
        });

      } catch (err) {
        this.$store.dispatch("notify", {
          message: 'Error al copiar',
          type: 'is-danger',
        });
      }
      document.body.removeChild(textArea);
    },
    async delone(item) {
      try {
        await apiServices.delete(
            `/deleteoneemployeecultura/${item.proceso}/${item.employeeid}`
        );
        this.findEmployeesCohorte();
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un error borrando la encuesta",
          type: "is-danger",
          position: "top-center",
          duration: 3000,
        });
      }
    },
    deleteoneemployee(item) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: `¿Realmente desea eliminar la encuesta de ${item.nombre}`,
          clase: "is-white",
          data: {
            proceso: this.proceso._id,
            tipo: "deleteone",
            employeeid: item._id,
          },
        },
      });
    },
    cancel() {
      this.chargeEmployee = false;
      this.search = "";
    },
    async deleteAllEmployees(procesoid) {
      try {
        await apiServices.delete(`/delallemployeescultura/${procesoid}`);
        this.findEmployeesCohorte();
      } catch (err) {
        console.log(err);
      }
    },
    deleteAll() {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "¡Cuidado!",
          message: "¿Realmente desea eliminar todas las encuestas?",
          clase: "is-white",
          data: {proceso: this.proceso._id, tipo: "deleteall"},
        },
      });
    },
    async findEmployeesCohorte() {
      try {
        const result = await apiServices.get(
            `/employeescultura/${this.proceso._id}`
        );
        if (result.data) {
          this.employees = result.data;
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message:
              "Ocurrio un error cargando los empleados. Inténtelo mas tarde",
          type: "is-warning",
          position: "top-center",
          duration: 3000,
        });
      }
    },
    downloadresponses(d) {
      if (d[0]) {
        this.dataToExport = [];
        this.dataToExport.push(d[0]);

        // Se parsea el valor boleano a texto
        this.dataToExport[0].agree ? this.dataToExport[0].agree = "Si" : this.dataToExport[0].agree = "No"

        //  Asignamos la informacion necesaria a nuevas variables
        let name = "CL7-Respuestas " + d[1];
        //  Se agrega la data al libro de excel
        var ws = XLSX.utils.json_to_sheet(this.dataToExport);

        //  Se configura el tamaño de cada columna
        const widths = this.widthCols(this.dataToExport);
        ws["!cols"] = widths

        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Respuestas");
        var nombreArchivo = name + ".xlsx";
        XLSX.writeFile(wb, nombreArchivo);

      } else {
        this.$store.dispatch("notify", {
          message: `Este Usuario no tiene respuestas`,
          type: "is-danger",
        });
      }
    },
    widthCols(data) {
      let values = []
      //  Se recorre todos los datos
      for (let i = 0; i < data.length; i++) {
        let cont = 0;
        // Se recorre la informacion de un Dato
        for (const d in data[i]) {
          // Si es la primera iteracion arma el dato con el tamaño del campo y lo guarda la array values
          if (i === 0) {
            let w = {width: (String(data[i][d]).length + 2)}
            values.push(w)
          }
              //  Si no es la primera iteracion compara los datos nuevo con los valores del array values
          //  con el fin de extraer el numero mas grande
          else {
            let w = (String(data[i][d]).length + 2)
            if (values[cont].width < w) {
              values[cont].width = w;
            }
            cont++;
          }
        }
      }
      // Se valian los tamaños de los titulos para evitar corte de texto en el Excel
      let cont = 0;
      for (const key in data[0]) {
        let w = (String(key).length + 2)
        if (values[cont].width < w) {
          values[cont].width = w;
        }
        cont++;
      }

      //  Se devuelve values con el formato necesario para el tamaño de columnas del Excel
      return values
    },
    async excelInfo(datos) {
      let data = [];
      try {
        for (let i = 0; i < datos.length; i++) {
          let d = datos[i];
          let user;

          if (d.status !== "Calculado") {
            user = {
              "Correo": d.email,
              "Cédula": d.cedula,
              "Nombre": d.nombre,
              "Estado": d.status
            };

            data.push(user);
          }
        }
        return {
          "data": [data],
          "names": ["Usuarios sin Calcular"]
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }

    },
    async excelPendientes() {
      try {
        let data = await this.excelInfo(this.employees)
        if (data.data.length > 0) {
          //  Recorremos las diferentes datas creando un Excel para cada uno
          for (let i = 0; i < data.data.length; i++) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data.data[i];
            let name = data.names[i];
            //  Se agrega la data al libro de excel
            let ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.widthCols(dataExc);
            ws["!cols"] = widths

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
            let nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);

          }
        } else {
          this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    },
    excelNog(){
      try {
        let data = this.nosave
        if (data.length > 0) {
            //  Asignamos la informacion necesaria a nuevas variables
            let dataExc = data;
            let name = "Usuarios no guardados";
            //  Se agrega la data al libro de excel
            let ws = XLSX.utils.json_to_sheet(dataExc);

            //  Se configura el tamaño de cada columna
            const widths = this.widthCols(dataExc);
            ws["!cols"] = widths

            //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hoja1");
            let nombreArchivo = name + ".xlsx";
            XLSX.writeFile(wb, nombreArchivo);
        } else {
          this.$store.dispatch("notify", {
            message: `No hay datos para descargar`,
            type: "is-link",
          });
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message: `Hubo un problema no se pudo generar el excel`,
          type: "is-danger",
        });
      }
    }
  },
  created() {
    this.findEmployeesCohorte();
    this.calculateallcultura()
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        if (nv.aceptar) {
          if (nv.data.tipo === "deleteall") {
            this.deleteAllEmployees(nv.data.proceso);
          }
          if (nv.data.tipo === "deleteone") {
            this.delone(nv.data);
          }
          if (nv.data.tipo === "calculateall") {
            this.calculateallcultura();
          }
          if (this.modalnotification.result.data === "confirm") {
            this.sendall()
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
.scroll-table {
  height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
}

.head-stick th {
  background: white;
  position: sticky;
  top: -3px; /* Don't forget this, required for the stickiness */
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  z-index: 60 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/Rencuestacultura.vue